import '../header/header';
import './anchor-content.scss';

import { scrollToElement, isElementPartiallyInViewport, getRootCssVariable } from '../helpers/helpers';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export class AnchorContent {
    constructor(target) {
        this.settings          = {
            targetOffset: getRootCssVariable('--header-anchor-offset') || 24, // https://gist.github.com/devballers/fddc690a8bf302f5892c3fb59fd94f10
        };
        this.element           = $(target);
        this.navLinks          = this.element.find(`.anchor-content__aside-navigation .anchor-content__link`);
        this.mainContent       = this.element.find('.anchor-content__body');
        this.sections          = this.mainContent.find('.anchor-content__body-section');
        this.backgroundElement = this.element.find('.anchor-content__bg-image');
        this.isPower           = $('body').hasClass('station-power');

        this.colorMap = {
            pink: '#ff006d',
            purple: '#d14fff',
            yellow: '#F4BB40',
        };

        this.ticking = false;

        this.element[0].anchorContentInstance = this;

        this.init();
    }

    init() {
        $(window).on('scroll load', this.onScroll.bind(this));
        this.navLinks.on('click', this.onAnchorClick.bind(this));
        $(window).on('resize', this.updateStickyContainerHeight.bind(this));
        this.startScrollingBackground();
        this.updateStickyContainerHeight();
    }

    onScroll() {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.handleScroll();
                this.ticking = false;
            });

            this.ticking = true;
        }
    }

    startScrollingBackground() {
        const elementCount  = this.sections.length;
        const totalRotation = elementCount * (this.isPower ? 15 : 55); // Full rotation with tilt

        gsap.set(this.backgroundElement, {rotation: -20});

        gsap.to(this.backgroundElement, {
            rotation: totalRotation,
            ease: 'none',
            scrollTrigger: {
                trigger: this.mainContent,
                start: 'top center', // 'top top+=96px',
                end: 'bottom center', // 'bottom bottom',
                scrub: 1,
                invalidateOnRefresh: true,
                // markers: true,
            },
        });
    }

    updateStickyContainerHeight() {
        if (!this.isPower) {
            return;
        }

        let totalHeight = 0;

        // Sum up heights of all sections
        this.sections.each((index, section) => {
            totalHeight += $(section).outerHeight(true);
        });

        // Get the text element from the last section and subtract its height
        const lastSectionText  = this.sections.last().find('.show__text');
        const lastSectionTitle = this.sections.last().find('.show__title');

        if (lastSectionText.length) {
            totalHeight -= lastSectionText.outerHeight(true);
        }

        if (lastSectionTitle.length) {
            totalHeight -= lastSectionTitle.outerHeight(true);
        }

        this.backgroundElement.parent().css('--totalHeight', `${totalHeight}px`);
    }

    handleScroll() {
        let sectionToActivate = this.sections[0].id;
        let shapeColor        = '';

        this.sections.map((index, section) => {
            if (isElementPartiallyInViewport(section)) {
                sectionToActivate = section.id;
                shapeColor        = section.getAttribute('data-color');
            }
        });

        if (sectionToActivate) {
            this.activateNavLink(sectionToActivate, shapeColor);
        } else {
            this.navLinks.removeClass('active');
        }
    }

    activateNavLink(activeSectionId, color) {
        const findAnchor = this.navLinks.filter(`[href="#${activeSectionId}"], [href*="/#${activeSectionId}"]`);

        this.backgroundElement.find('svg').css('fill', this.colorMap[color]);

        if (findAnchor.hasClass('active')) {
            return;
        }

        this.navLinks.removeClass('active');
        findAnchor.addClass('active');
    }

    onAnchorClick(event) {
        event.preventDefault();
        const target = $(event.currentTarget);

        this.scrollIntoView(target[0].getAttribute('href'));
    }

    scrollIntoView(ID) {
        const firstSectionID = this.sections[0].getAttribute('id');
        const sectionSpacing = this.sections.length > 0 ? $(this.sections[1]).css('padding-top') : 0;
        const selector       = ID;
        const target         = $(selector);
        const targetNode     = target.get(0);

        let totalOffset = this.settings.targetOffset;

        if (selector.includes(firstSectionID)) {
            totalOffset += parseInt(sectionSpacing);
        }

        scrollToElement(targetNode, totalOffset);
        history.pushState(null, null, selector);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.js-anchor-content');

    elements.forEach((element) => new AnchorContent(element));
});
